export const BASE_URL = "https://prodapi.babytuesday.link";
